<template>
	<div class="py-0 fixed-bottom z-index-1029">
		<div class="w-100">
		  <b-row class="justify-content-center" no-gutters>
		    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="py-2 light-shadow bg-white">
					<div class="w-100">
						<b-row no-gutters>
							<b-col cols="3" class="text-center">
								<router-link :to="'/'+getMerchant().code">
									<img v-if="HomeMenu" class="mb-1" src="../../assets/img/icon/menu/icn_home.png" width="18" />
									<img v-else class="mb-1" src="../../assets/img/icon/menu/icn_home_inactive.png" width="18" />
									<p class="mb-0 overline text-center" :class="{'text-green' : HomeMenu}" >{{$t('general.home')}}</p>
								</router-link>
							</b-col>
							<b-col cols="3" class="text-center">
								<router-link :to="'/'+getMerchant().code+'/cart'">
									<div class="custom-badges" v-if="CartItemQty>0">
                    <p class="font-reguler ls-0-4 text-white mb-0">{{CartItemQty}}</p>
                	</div>
              		<img v-if="CartMenu" class="mb-1" src="../../assets/img/icon/menu/icn_calendar.png" width="18">
									<img v-else class="mb-1" src="../../assets/img/icon/menu/icn_calendar__inactive.png" width="18">
									<p class="mb-0 overline text-center" :class="{'text-green' : CartMenu}">{{$t('general.order')}}</p>
								</router-link>
							</b-col>
							<b-col cols="3" class="text-center">
								<router-link :to="'/'+getMerchant().code+'/feedback'">
									<img v-if="FeedbackMenu" class="mb-1" src="../../assets/img/icon/menu/icn_chat.png" width="18">
									<img v-else class="mb-1" src="../../assets/img/icon/menu/icn_chat_inactive.png" width="18">
									<p class="mb-0 overline text-center" :class="{'text-green': FeedbackMenu}">{{ $t('general.feedback') }}</p>
								</router-link>
							</b-col>
							<b-col cols="3" class="text-center">
								<router-link v-if="getMerchant().merchant_type != 'restaurant'" :to="'/'+getMerchant().code+'/account'">
									<img v-if="AccountMenu" class="mb-1" src="../../assets/img/icon/menu/icn_profile.png" width="18">
									<img v-else class="mb-1" src="../../assets/img/icon/menu/icn_profile_inactive.png" width="18">
									<p class="mb-0 overline text-center" :class="{'text-green': AccountMenu}">{{$t('general.profile')}}</p>
								</router-link>
								<router-link v-else :to="'/'+getMerchant().code+'/r/order-history'">
									<img v-if="HistoryMenu" class="mb-1" src="../../assets/img/icon/menu/icn_history.png" width="18">
									<img v-else class="mb-1" src="../../assets/img/icon/menu/icn_history_inactive.png" width="18">
									<p class="mb-0 overline text-center" :class="{'text-green': HistoryMenu}">{{$t('general.history')}}</p>
								</router-link>
							</b-col>
						</b-row>
					</div>
		    </b-col>
		  </b-row>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from "vuex";
	export default{
		data(){
			return{

			}
		},
		computed:{
			CartItemQty(){
				if(this.getMerchant().merchant_type == 'ticket'){
					return this.getTicketCart().qty
				}else if(this.getMerchant().merchant_type == 'restaurant'){
					return this.getRestaurantOrderQty()
				}
			},
			HomeMenu(){
				let data = false
				if (this.$route.name == 'HomePage' || this.$route.name == 'TicketDetail' || this.$route.name == 'TicketList') {
					data = true
				}
				return data 
			},
			CartMenu(){
				let data = false
				if (this.$route.name == 'DokuRedirect' || this.$route.name == 'Cart' || this.$route.name == 'TicketOrderHistory'|| this.$route.name == 'TicketOrderHistoryDetail') {
					data = true
				}
				return data
			},
			FeedbackMenu(){
				let data = false
				if (this.$route.name == 'FeedBack' || this.$route.name == 'FeedBackForm') {
					data = true
				}
				return data
			},
			AccountMenu(){
				let data = false
				if (this.$route.name == 'Account') {
					data = true
				}
				return data
			},
			HistoryMenu(){
				let data = false
				if (this.$route.name == 'RestaurantOrderHistory' || this.$route.name == 'RestaurantOrderHistoryDetail') {
					data = true
				}
				return data
			}
		},
		methods:{
			...mapGetters(['getTicketCart','getMerchant', 'getRestaurantCart','getRestaurantOrderQty'])
		}
	}
</script>
<style scoped>
.custom-badges{
    position: absolute;
    background-color: #ff6144;
    display: table;
    top: -6px;
    right: 32px;
    border: 1px solid #fff;
    color: #fff;
    font-weight: bold;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/general/BottomNavbar.vue